var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.permissionItem.subItems),function(subItem){return _c(_vm.switchComponent(subItem.type),{key:subItem.title,tag:"component",attrs:{"sub-item":subItem,"is-opened":_vm.isOpened(subItem.relatedPermissions)},on:{"switch-change":function($event){return _vm.$emit('update-role-permissions', $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }